import { configureStore } from "@reduxjs/toolkit";
import breadCrumbsSlice from "./breadCrumbs/breadCrumbsSlice";
import aclSlice from "./acl/aclSlice";

export default configureStore({
  reducer: {
    breadCrumbs: breadCrumbsSlice,
    acl: aclSlice,
    // Add redux file here
  },
});
